module.exports = __webpack_public_path__ + "img/icon-banxueleixing_1@2x.79a142b0.png";